<style lang="scss">
.export-dialog-modal {
  .el-dialog__body {
    padding: 10px 20px;
  }
  .export-container {
    .field-row {
      display: flex;
      align-items: center;
    }
    .label {
      font-weight: 600;
      padding-left: 10px;
    }
  }
}
</style>
<template>
  <div class="export-dialog">
    <el-dialog
      class="export-dialog-modal"
      title="导出"
      :visible="showModal"
      :show-close="false"
      width="600px"
      modal-append-to-body
      append-to-body
      destroy-on-close
      top="5vh"
    >
      <div class="export-container">
        <div class="field-row">
          <div class="label">
            文件名称：
          </div>
          <div class="name">
            {{ fileName }}
          </div>
        </div>
        <div class="field-row">
          <div class="label">
            生成时间：
          </div>
          <div class="name">
            {{ createTime }}
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="handlecloseModal"
        >取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="handleComfirmModal"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * @author lkj
 * @description 群聊选择器
 * @see The https://ba-uat.shopex123.com/customer/index @view/customer/index.vue
 * @since version 1.0
 * @returns {Array}
 * @param {Object} value 传入数据源:{url, params}
 * @param {Boolean} isShow 控制导出框显隐
 */
export default {
  name: 'SpGroupChatPicker',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isShow: Boolean
  },
  data () {
    const { data } = this.value
    return {
      showModal: false,
      fileName: '',
      createTime: '',
      fileUrl: ''
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler (val) {
        this.showModal = val
      }
    }
  },
  mounted () {
    this.handleExport()
  },
  methods: {
    handlecloseModal () {
      this.showModal = false
      this.$emit('close')
    },
    handleToggleModal () {
      this.showModal = true
    },
    async handleExport () {
      const { url, params } = this.value.data
      const { file_name, created_at, url: fileUrl } = await this.$http.post(url, params)
      this.fileName = file_name
      this.createTime = created_at
      this.fileUrl = fileUrl
    },
    async handleComfirmModal () {
      window.open(this.fileUrl, '_blank')
      this.showModal = false
    },
    // 选择
    handleSelect (item) {
      const fd = this.select.find((v) => v.id == item.id)
      if (fd) {
        const index = this.select.findIndex((v) => v.id == item.id)
        this.select.splice(index, 1)
      } else {
        this.select.push(item)
      }
    },
    isActive (item) {
      return this.select.find((v) => v.id == item.id)
    },
    // 删除
    deleteItem (index) {
      this.select.splice(index, 1)
    },
    selectAll (e) {
      if (e) {
        this.select = this.list.map((item) => {
          return item
        })
      } else {
        this.select = []
      }
    },
    onChangePage (p) {
      console.log('p: ', p)
      this.goPage(p)
    },
    seachByKeyword () {
      this.refresh(true)
    }
  }
}
</script>
